import { useLingui } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { Button } from 'designSystem/components/Button'
import { Spinner } from 'designSystem/components/Spinner'
import { Text } from 'designSystem/components/Text'
import { EvalQueueNavigation } from 'features/knowledgeDocumentViewer/components/metadata/EvalQueueNavigation'
import { usePageMetadataEvalSession } from 'features/knowledgeDocumentViewer/contexts/PageMetadataEvalSessionContext'
import { useCallback } from 'react'

export function EvalPagePending({
  isLoading,
  onRetry,
}: {
  isLoading: boolean
  onRetry: () => void
}) {
  const { t } = useLingui()
  const { canGoBack, canGoForward, previous, next, runExclusive, isBusy } =
    usePageMetadataEvalSession()
  const handleNext = useCallback(() => {
    void runExclusive(() => next())
  }, [runExclusive, next])
  return (
    <Box display='flex' direction='column' gap='md'>
      {isLoading ? (
        <Spinner aria-label={t`Loading page metadata…`} />
      ) : (
        <>
          <Text>{t`This page's metadata is unavailable. Retry or continue to another page.`}</Text>
          <Button onClick={onRetry}>{t`Retry loading page`}</Button>
        </>
      )}
      <EvalQueueNavigation
        canGoBack={canGoBack}
        canGoForward={canGoForward}
        onPrevious={previous}
        onNext={handleNext}
        isBusy={isBusy}
      />
    </Box>
  )
}
